import { lazy, useContext, useEffect, useState } from 'react';
import './Headerstyle.css';
import { AppContext } from '../../context/AppContext';
import logo from '../../assets/logo/sanaLogo.png';
import Modal from '../modal/Modal';
import { apiPath } from '../../global';
import axios from 'axios';
const ChangePassword = lazy(() => import('../../forms/User/password/ChangePassword'));
const EditProfile = lazy(() => import('../../forms/User/editprofile/EditProfile'));
import { appStore } from '../../context/AppContext';
import { Link, useNavigate } from 'react-router-dom';
import ToggleButton from 'react-toggle-button';
import { toast } from 'react-toastify';

export default function Header() {

    const tokenData = useContext(AppContext);
    const [show, setShow] = useState(false);
    const [showNotify, setNotify] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [toggle, setToggle] = useState(false);
    const [form, setForm] = useState(0);
    const [alerts, setAlerts] = useState([]);
    const navigate = useNavigate();

    let nCount = appStore(state => state.notifCount);
    let resetCount = appStore(state =>  state.resetCount);

    const getNotifDb = () => {
            axios.get(`${apiPath}/usernotification/getUserNotifications/${tokenData.userID}`).then(res => {
                if(res.data.success){
                    setAlerts(res.data.data);
                }
            });
        }

    const close = () => {
        setShowModal(false);
    }

    const formsList = [
        {formName: "Change Password", comp: <ChangePassword close={close} />},
        {formName: "Edit Profile", comp: <EditProfile close={close} />}
      ];

    useEffect(() => {
        getNotifDb();
        
    },[])

    useEffect(() => {
        if(showNotify) {
            getNotifDb();
        }
    },[showNotify])

    const handleToggle = (value) => {
        debugger;
        // if true send request to set Summer
        // if false send request to set Winter
        setToggle(!value);

        axios.put(`${apiPath}/general/resetSeason/${value ? "summer" : 'winter'}`).then(res => {
            if(res.data.success){
               toast.success(`${res.data.message} to ${value ? "summer" : 'winter'}`);
            }
            else{
            toast.error(res.data.message);
            }
        }).catch(err => {
            console.log(err);
            toast("Unable to change Season");
        }).finally(() => {
        })
    }

    useEffect(() => {
        debugger;
        if(show){
            axios.get(`${apiPath}/dashboard/getAllSensorThreshold`).then(res => {
                
                if(res.data.success){
                setToggle(res.data.data[1].season.toString().toLowerCase() == 'winter' ? true : false);
                }
                else{
                toast.error(res.data.message);
                }
            }).catch(err => {
                console.log(err);
                toast("Unable to get Season");
            }).finally(() => {
            })
        }
        
    }, [show])

    return (

        <div className='header-main-div'>
            <div className='left'>
                
                <img loading='lazy' src={logo} width={250} height={50} />
                {/* <b className='company-name'>{`${props.companyName}`}</b> */}
                
            </div>

            {/* <div className='mid'>Current Company: {globalData.currCompany !== undefined ? globalData.currCompany.name : ''}</div> */}

            <div className='right'>
                <div className='menu-parent-not' onClick={() => {setNotify(prev => !prev); resetCount();}}>
                    <i className='fa fa-bell fa-2x'></i>
                    <span className='counter'>{showNotify || nCount === 0 ? '' : nCount}</span>
                    {
                        showNotify ? 
                            <div className='menu-div-not'>
                                <p>Notifications</p>
                                {
                                    alerts !== undefined && alerts.length > 0 ? 

                                    alerts.map((item, index) => <div key={index} className='notif-item'>
                                        
                                        <div style={{display:'flex', justifyContent:'space-between', marginBottom:'4px'}}>
                                            <p>{item.CreatedBy}</p>
                                            <p>{item.CreatedAt}</p>
                                        </div>
                                        <p>{item.Message}</p>
                                        
                                    </div>) : <span style={{display:'block',textAlign:'center', color:'var(--text-color)'}}>No Notifications</span>
                                }
                            </div> : null
                    }
                </div>
                {/* <img src={notificationIcon} width={50} height={50} style={{transform: 'scale(1.3,1.3)'}} /> */}
                {/* <img src={require('../../assets/logo/AetherIoT_Logo_2400x800.png')} width={160} height={50}/> */}
                <div className='menu-parent' onClick={() => {setShow(!show);}}>
                    <span>{tokenData.userName.substr(0,1)}</span>
                    
                    {
                        show ? 
                            <div className='menu-div'>
                                <p>{tokenData.userName}</p>
                                <p onClick={() => {
                                    setForm(1);
                                    setShowModal(true);
                                }}><i className='ri-user-line fa-lg' style={{padding:'8px', color:'var(--secondary-color)'}} />Profile</p>
                                <p onClick={() => {
                                    setForm(0);
                                    setShowModal(true);
                                }}><i className='ri-lock-line fa-lg' style={{padding:'8px', color:'var(--secondary-color)'}} />Change Password</p>
                                {
                                    tokenData.roleID === 1 ?
                                <div style={{display: 'flex', paddingLeft:'25px', color:'black', fontWeight:'500'}}> SEASON: &nbsp; &nbsp; <ToggleButton
                                        value={toggle}
                                        activeLabel='Win.'
                                        inactiveLabel='Sum.'
                                        trackStyle={{ width: '60px', height: '25px' }}
                                        colors={{
                                            activeThumb: {
                                                base: 'white',
                                            },
                                            inactiveThumb: {
                                                base: 'white',
                                            },
                                            active: {
                                                base: '#499DFE',
                                                hover: '#499DFE',
                                            },
                                            inactive: {
                                                base: '#D9D9D9',
                                                hover: '#D9D9D9',
                                            }
                                        }}
                                        onToggle={(value) => { handleToggle(value)}} /></div> : <></>
                                }
                                <p onClick={() => {
                                    localStorage.clear();
                                    navigate("/");
                                    window.location.reload();
                                    
                                }}><i className='ri-logout-circle-line fa-lg' style={{padding:'8px', color:'var(--secondary-color)'}} />
                                Logout </p>
                            </div> : null
                    }
                    
                </div>

            </div>
            { showModal ? 
                        
                <Modal close={close} formName={formsList[form].formName}> {formsList[form].comp} </Modal> : null
            }
        </div>
  )
}
